/* eslint-disable react/no-unescaped-entities */
import { MinutePageHeader } from 'components/minute/layout/MinutePageHeader';
import { MinutePageTitle } from 'components/minute/layout/MinutePageTitle';
import { EFonts } from 'libs/styles/styling';
import { MinuteWhiteBg } from 'pages/minute/shared/MinuteWhiteBg';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const TermsPage = (props: Props): JSX.Element => {
    return (
        <S_TermsPage className={props.className}>
            <S_Center>
                <MinutePageHeader />
                <S_Mid>
                    <MinutePageTitle title="Terms and conditions" />
                    <S_Content>
                        <S_P>Last Updated: July 4, 2023</S_P>
                        <S_P>
                            Welcome to Mapheim, a software as a service (SaaS) platform for creating
                            and using interactive maps ("Service").
                        </S_P>
                        <S_Title>1. ACCEPTANCE OF TERMS</S_Title>
                        <S_P>
                            By accessing or using our Service, you agree to be bound by these terms
                            and conditions ("Terms"). If you do not agree with these Terms, you may
                            not use the Service.
                        </S_P>
                        <S_Title>2. CHANGES TO TERMS</S_Title>
                        <S_P>
                            Mapheim reserves the right to change or modify these Terms at any time
                            and in our sole discretion. We will provide notice of any changes by
                            posting the revised Terms on our platform. Your continued use of the
                            Service after any change or modification constitutes your acceptance of
                            the revised Terms.
                        </S_P>
                        <S_Title>3.SERVICE USE AND LIMITATIONS</S_Title>
                        <S_P>
                            Mapheim provides you with access to interactive maps, subject to a view
                            limit. Once the view limit has been reached for a particular map, that
                            map may become unavailable. The view limit is subject to change at
                            Mapheim's sole discretion.
                        </S_P>
                        <S_Title>4. INQUIRIES AND SPECIAL OFFERS </S_Title>
                        <S_P>
                            For more information about our Service or to inquire about special
                            deals, please contact us at info@mapheim.com.
                        </S_P>
                        <S_Title>5. USER OBLIGATIONS</S_Title>
                        <S_P>
                            By using our Service, you agree not to misuse the Service or help anyone
                            else to do so. For example, you must not do any of the following in
                            connection with the Service: Violate or attempt to violate Mapheim’s
                            security features Use the Service to violate applicable laws Share your
                            account with any other person or entity
                        </S_P>
                        <S_Title>6. INTELLECTUAL PROPERTY</S_Title>
                        <S_P>
                            The Service, including all content and materials provided on the
                            Service, is protected by copyright, trademark, and other intellectual
                            property laws. Except as expressly provided, Mapheim does not grant any
                            express or implied rights to use the Service.
                        </S_P>
                        <S_Title>7. DISCLAIMERS</S_Title>
                        <S_P>
                            The Service and all included content are provided on an "as is" basis
                            without warranty of any kind. Mapheim does not guarantee the accuracy,
                            reliability, completeness, or timeliness of the Service or any included
                            content.
                        </S_P>
                        <S_Title>8. LIMITATION OF LIABILITY</S_Title>
                        <S_P>
                            Mapheim shall not be liable for any direct, indirect, incidental,
                            special, consequential, or exemplary damages, including damages for loss
                            of profits, goodwill, use, data, or other intangible losses resulting
                            from the use of or inability to use the Service.
                        </S_P>
                        <S_Title>9. INDEMNIFICATION</S_Title>
                        <S_P>
                            You agree to indemnify and hold Mapheim harmless from any claim or
                            demand due to or arising out of your use of the Service, your violation
                            of these Terms, or your infringement of any intellectual property or
                            other right of any person or entity.
                        </S_P>
                        <S_Title>10. GOVERNING LAW</S_Title>
                        <S_P>
                            These Terms shall be governed by and construed in accordance with the
                            laws of the jurisdiction in which Mapheim operates.
                        </S_P>
                        <S_Title>11. CONTACT US</S_Title>
                        <S_P>
                            If you have any questions about these Terms, please contact us at
                            info@mapheim.com.
                        </S_P>
                    </S_Content>
                </S_Mid>
            </S_Center>
            <MinuteWhiteBg />
        </S_TermsPage>
    );
};

const S_TermsPage = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    align-items: center;
`;

const S_Center = styled.div`
    display: flex;
    width: 1260px;
    margin: 40px 0 0 0;
    flex-direction: column;
    z-index: 1;
    justify-content: center;
`;

const S_Mid = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const S_Content = styled.div`
    border-radius: 7px;
    background: #efefef;
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1);
    padding: 30px 30px;
    display: flex;
    width: 800px;
    flex-direction: column;
    margin: 30px 0 30px 0;
`;

const S_Title = styled.div`
    font-size: 14px;
    font-family: ${EFonts.Medium};
    margin: 15px 0 5px 0;
`;

const S_P = styled.div`
    font-size: 13px;
    font-family: ${EFonts.Regular};
    line-height: 19px;
`;
